import type {ZodType} from 'zod';

// Las consultas de las tablas viven en la direccion (URL): asi se puede
// compartir un enlace o volver atras y encontrar los mismos filtros.
export function desdeParametros<T>(parametros: URLSearchParams, esquema: ZodType<T>): T {
  const crudo = Object.fromEntries(parametros.entries());
  const resultado = esquema.safeParse(crudo);
  if (resultado.success) return resultado.data;
  // Si algun parametro viene mal escrito, se ignora solo ese.
  const limpio: Record<string, string> = {};
  for (const [clave, valor] of Object.entries(crudo)) {
    if (esquema.safeParse({[clave]: valor}).success) limpio[clave] = valor;
  }
  return esquema.parse(limpio);
}

// Solo lo que se aparta de los valores por defecto va a la direccion.
export function aParametros(consulta: Record<string, unknown>, porDefecto: Record<string, unknown>): URLSearchParams {
  const parametros = new URLSearchParams();
  for (const [clave, valor] of Object.entries(consulta)) {
    if (valor === undefined || valor === null || valor === '') continue;
    const texto = Array.isArray(valor) ? valor.join(',') : String(valor);
    const base = porDefecto[clave];
    const textoBase = Array.isArray(base) ? base.join(',') : base === undefined ? undefined : String(base);
    if (textoBase === texto) continue;
    parametros.set(clave, texto);
  }
  return parametros;
}
